export const pharmacyRouteDef = [ 
    {
        path: 'clearance_status_pharmacy',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance' 
        }
    },
    {

        path: ':resource/patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
        }
    },
    {
        path:':orderId/:resource/viewFormSixty',
        component:'WalkInRetrunComponent',
        data : {
            selector: 'kx-walk-in-retrun',
            action:'viewFormSixty'
        }
    },
    {
        path:':orderId/:resource/order',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'pharmacy_OP_Issue',
            action: 'LIST',
        }
    },
    {
        path:':orderId/:resource/patient_issued_items',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'pharmacy_OP_Issue',
            action: 'LIST',
        }
    },
    {   
        
        path:'order_patient_details/pharmacy_order_details',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'medicationOrderDetails_patient',
            action: 'LIST',
        }
    },
    {
        path:':resource/patientDraftOrderPayment',
        component:'PatientPortalDraftOrders',
        data : {
            selector: 'kx-patient-portal-draft-order',
            resource: 'medicationOrderDetails_patient'
        }
    },
    {
        path:':issueId/:resource/issue',
        component:'EditableGridWithBannerComponent',
        data : { 
            selector: 'kx-editable-grid-with-banner'
        }
    },
    {
        path:':id/:resource/completedReturn',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'pharmacy_OP_Completed_Return',
            action: 'LIST',
        }
    },
    {
        path:'opMedicationOrder_patientLayout',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'opMedicationOrder_patientLayout',
            action: 'LIST',
        }
    },
    {
        path:':returnId/:resource/return',
        component:'PharmacyIpReturnComponent',
        data : {
            selector: 'kx-pharmacy-ip-return'
        }
    },
    {
        path:':issueId/:resource/returnList',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'pharmacy_IP_Completed_Return',
            action: 'LIST',
        }
    },
    {
        path:':issueId/:resource/cancelList',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'cancel_ip_medication_order_details',
            action: 'LIST',
        }
    },
    {
        path:':resource/orderDetails',
        component:'PharmacyOrderComponent',
        data : {
            selector: 'kx-pharmacy-order'
        }
    },
    { 
        path:':orderId/:resource/orderDetailsDemo',
        component:'IpPharmacyComponent', 
        data : {
            selector: 'app-ip-pharmacy',
            resource: 'pharmacy_OP_Walkin_Draft'
        }
    },
    {
        path:'pharmacy_Pat_verification/pat_varification',
        component:'PatVerificationComponent',
        data : {
            selector: 'app-pat-verification',
            resource: 'pharmacy_Pat_verification',
            action: 'LIST',
        }
    },
    {
        path:'OP_pharmacy_Pat_verification/OP_pat_varification',
        component:'PatVerificationComponent',
        data : {
            selector: 'app-pat-verification',
            resource: 'OP_pharmacy_Pat_verification',
            action: 'LIST',
        }
    },
    
    //  {
    //     path:':orderId/:resource/pat_varification',
    //     component:'UiEngineComponent',
    //     data : {
    //         selector: 'app-ui-engine',
    //         resource: 'pharmacy_IP_PAT_Varification',
    //         action: 'LIST',
    //     }
    // },

    {
        path:'ip_pharmacy_return/returnDetails',
        component:'PharmacyIpReturnComponent',
        data : {
            selector: 'kx-pharmacy-ip-return'
        }
    },
    {
        path:':id/:resource/opOrders',
        component:'OpOrdersComponent',
        data : {
            selector: 'kx-op-orders'
        }
    },
    {
        path:':issueId/:resource/walkinReturn',
        component:'WalkInRetrunComponent',
        data : {
            selector: 'kx-walk-in-retrun'
        }
    },
    {
        path:':issueId/:resource/ipSplitBillReturn',
        component:'IpSplitBillRetrunComponent',
        data : {
            selector: 'kx-ip-split-bill-retrun'
        }
    },
    {
        path: 'settleDue',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'due_settlement',
            action: 'ADD',
        }
    },
    {
        path: 'settleDueip',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'due_settlementip',
            action: 'ADD',
        }
    },
    {
        path:':issueId/:resource/Opreturn',
        component:'WalkInRetrunComponent',
        data : {
            selector: 'kx-walk-in-retrun'
        }
    },
    {
        path:':resource/walkIn',
        component:'WalkInPharmacyComponent',
        data : {
            selector: 'kx-walk-in-pharmacy',
            resource: 'pharmacy_walkin'
        }
    },
    {
        path:':resource/approvebilling',
        component:'WalkinPharmacyApproveComponent',
        data : {
            selector: 'kx-walkin-pharmacy-approve',
            resource: 'pharmacy_walkin_approve'
        }
    },
    {
        path:':resource/approveMedicationSplitBill',
        component:'IpPharmacyApproveBillComponent',
        data : {
            selector: 'app-ip-pharmacy-approve-bill',
            resource: 'pharmacy_medication_approve'
        }
    },
    {
        path:':resource/approveSplitBill',
        component:'IpPharmacyApproveBillComponent',
        data : {
            selector: 'app-ip-pharmacy-approve-bill',
            resource: 'pharmacy_IP_Approve'
        }
    },
    {
        path:':resource/approvebillingDirect',
        component:'WalkinPharmacyApproveComponent',
        data : {
            selector: 'kx-walkin-pharmacy-approve',
            resource: 'pharmacy_direct_approve'
        }
    },
    {
        path:'OporderProcess',
        component:'WalkInPharmacyComponent', 
        data : {
            selector: 'kx-walk-in-pharmacy',
            resource: 'pharmacy_OP_Order'
        }
    },
    {
        path:':issueId/:resource/OporderProcessDraft',
        component:'WalkInPharmacyComponent', 
        data : {
            selector: 'kx-walk-in-pharmacy',
            resource: 'pharmacy_OP_Order_Draft'
        }
    },
    {
        path:':issueId/:resource/walkinDfraft',
        component:'WalkInPharmacyComponent', 
        data : {
            selector: 'kx-walk-in-pharmacy',
            resource: 'pharmacy_OP_Walkin_Draft'
        }
    },
    {
        path:':issueId/:resource/consigment_walkin_draft',
        component:'WalkInPharmacyComponent', 
        data : {
            selector: 'kx-walk-in-pharmacy',
            resource: 'pharmacy_walkin_consignment_draft'
        }
    },
    {
        path:'newSampleEditableGrid',
        component:'SampleEditableGridComponent',
        data : {
            selector: 'kx-sample-editable-grid'
        }
    },
    {
        path:':id/newOrder',
        component:'IpPharmacyNewOrderComponent',
        data : {
            selector: 'app-ip-pharmacy-new-order',
            resource: 'pharmacy_IP_Order_new_order'
        }
    },
    {
        path: ':id/newSplitBillReturn',
        component: 'NewSplitBillReturnComponent',
        data: {
            selector: 'app-new-split-bill-return',
            resource: 'split_bill_return_filter_eg'
        }
    },
    {
        path:'opPharmacyDispenseOrder',
        component:'OpPharmacyDispenseOrderComponent', 
        data : {
            selector: 'app-op-pharmacy-dispense-order',
            resource: 'op_pharmacy_dispenseOrder'
        }
    },
    {
        path: '/medicationissue/ackRejectedItem',
        component: 'AcknowledgeRejectedItemComponent',
        data: {
            selector: 'app-acknowledge-rejected-item',
            resource: 'ip_medication_rejected_item_pharmacy',
            input: 'ip_medication_rejected_item_pharmacy',
            action: 'Add'
        }
    },
    {
        path: 'acknowledgeRejectItem',
        component: 'AcknowledgeRejectedItemComponent',
        data: {
            selector: 'app-acknowledge-rejected-item',
            resource: 'ip_medication_rejected_item_pharmacy'
        }
    },
]

